import React from 'react'
import { useField, useFormikContext } from 'formik'

import CheckBox from 'devextreme-react/check-box'

import './index.scss'
import { FormErrors } from 'components/forms/form-errors'


export const CheckBoxInput = ({label, readOnly = false, useInt = false, text='', ...props}: any) => {
    const { setFieldValue } = useFormikContext()
    const [field, meta] = useField(props)

    const handleChange = (e: any) => {
        if (useInt && e.value !== null) {
            setFieldValue(field.name, e.value ? 1 : 0, true)
        } else {
            setFieldValue(field.name, e.value, true)
        }
    }

    return (
        <div className='rb-item mb-1'>
            <div>
                <label htmlFor={props.id || field.name} className='dx-field-label'>{label}</label>
                <br />
                <CheckBox
                    text={text}
                    name={field.name}
                    value={Boolean(field.value)}
                    onValueChanged={handleChange}
                    className='dx-field-input'
                    isValid={!(meta.touched && meta.error)}
                    disabled={readOnly}
                />
            </div>
            <FormErrors meta={meta} />
        </div>
    )
}
